/** Flatten a list of WBS-pathed activities into schedule-page-style group +
 *  activity rows. Shared by the Overdue and Auto Actuals tabs. */

export interface WbsGroupRow {
  kind: "wbs";
  key: string;
  name: string;
  depth: number;
  count: number;
}
export interface ActivityRow<T> {
  kind: "act";
  key: string;
  act: T;
}
export type GroupedRow<T> = WbsGroupRow | ActivityRow<T>;

interface HasWbs {
  activity_id: number;
  task_name: string;
  wbs_path: string[];
}

interface Node<T> {
  name: string;
  depth: number;
  children: Map<string, Node<T>>;
  rows: T[];
}

export function groupByWbs<T extends HasWbs>(items: T[]): GroupedRow<T>[] {
  const root: Node<T> = { name: "", depth: -1, children: new Map(), rows: [] };
  for (const a of items) {
    let node = root;
    const path = a.wbs_path.length ? a.wbs_path : ["(ungrouped)"];
    for (const name of path) {
      let child = node.children.get(name);
      if (!child) {
        child = { name, depth: node.depth + 1, children: new Map(), rows: [] };
        node.children.set(name, child);
      }
      node = child;
    }
    node.rows.push(a);
  }
  const count = (n: Node<T>): number => {
    let c = n.rows.length;
    n.children.forEach((k) => { c += count(k); });
    return c;
  };
  const out: GroupedRow<T>[] = [];
  const walk = (n: Node<T>) => {
    Array.from(n.children.values())
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach((child) => {
        out.push({ kind: "wbs", key: `w${child.depth}:${child.name}:${out.length}`, name: child.name, depth: child.depth, count: count(child) });
        walk(child);
        child.rows
          .sort((a, b) => a.task_name.localeCompare(b.task_name))
          .forEach((act) => out.push({ kind: "act", key: `a${act.activity_id}`, act }));
      });
  };
  walk(root);
  return out;
}
